import { useState } from 'react'

import { DateSelect } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, dateTime } from '../Controls'

import { DateTimeProviderProps } from './DateTimeProviderProps'

export function DateSelectUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('disabled', false))
      .add(dateTime('maxValue', null))
      .add(dateTime('minValue', null))
      .add(boolean('monthInput', true))
      .add(boolean('weekDays', true))
      .add(dateTime('value', null))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <DateTimeProviderProps>
      <Component
        {...props.getValues()}
        Component={DateSelect}
        name='DateSelect'
        onChange={handleChange}
      />
      <ComponentProps name='DateSelect' value={props} onChange={setProps} />
    </DateTimeProviderProps>
  )
}
